// extracted by mini-css-extract-plugin
export default {"root":"PaymentSuccess_root__Yl7lT","test":"PaymentSuccess_test__SlgAP"};